<template>
  <div class="menu-tab white" id="fav">
      <div class="menu-tab-content">
        <div class="page-list">
          <transition-group name="fade">
          <div class="page fav" v-for="fav in pages" :key="fav.pageNumber">
            <router-link :to="{ name: 'Page', params: { pageNumber: fav.pageNumber } }" :alt="`Gå til side ${fav.pageNumber}`" :title="`Gå til side ${fav.pageNumber}`">
              <PageThumb class="page-thumb" :page="fav" />
              {{ fav.pageNumber }}
              <a href="#" @click.prevent="removeFavorite(fav.pageNumber)" class="remove-btn" title="Fjern som favoritt">&times;</a>
            </router-link>
          </div>
          </transition-group>
        </div>
      </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import PageThumb from '@/views/page/PageThumb'
export default {
  methods: {
    ...mapActions(['removeFavorite'])
  },
  computed: {
    ...mapGetters(['favorites']),
    pages () {
      return this.favorites.map(fav => { return this.$store.getters.pages.find(page => page.pageNumber === fav.pageNumber) })
    }
  },
  components: {
    PageThumb
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/PageFavTab.vue